import React, {useEffect, useState, useRef} from 'react';
import {db} from '../../firebase/index'

const SelectField = (props) => {
    const inputRef = useRef();
    const [options, setOptions] = useState([]);

    useEffect(() => {
        switch (props.type) {
            case "gender":
                setOptions([
                    {value: "", label: "未回答"},
                    {value: "男性", label: "男性"},
                    {value: "女性", label: "女性"},
                ]);
                break;
            case "prefecture":
                const fetchPrefectures = async () => {
                    let list = [{value: "", label: "未回答"}];
                    const snapshot = await db.collection('prefectures').doc('prefectures').get();
                    const prefectures = snapshot.data().prefectures;
                    prefectures.map(prefecture => list.push({value: prefecture, label: prefecture}));
                    setOptions(list)
                };
                fetchPrefectures();
                break;
        }
    }, [inputRef]);

    return (
        <select ref={inputRef} value={props.value} onChange={e => props.onChange({[props.type] :e.target.value})}>
            {options.map(data => <option value={data.value}>{data.label}</option>)}
        </select>
    );
};

export default SelectField;